import { render, staticRenderFns } from "./ModalActivateTerm.vue?vue&type=template&id=ca293b52"
import script from "./ModalActivateTerm.vue?vue&type=script&lang=js"
export * from "./ModalActivateTerm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports